import { Button, EmptyState, ErrorState } from '@portal/ui';
import { Link, type ErrorComponentProps } from '@tanstack/react-router';
import { Compass } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <EmptyState
      className="mt-10"
      icon={Compass}
      title={t('errors.notFoundTitle')}
      description={t('errors.notFoundHint')}
      action={
        <Button asChild variant="secondary" size="sm">
          <Link to="/">{t('errors.backHome')}</Link>
        </Button>
      }
    />
  );
}

export function RouteError({ reset }: ErrorComponentProps) {
  const { t } = useTranslation();
  return (
    <ErrorState
      className="mt-10"
      title={t('errors.unexpectedTitle')}
      description={t('errors.unexpectedHint')}
      retryLabel={t('shell.retry')}
      onRetry={reset}
    />
  );
}
